export default function PHP_parse_str() {
  return (
    <div>
      <h1>PHP_parse_str</h1>
    </div>
  );
}
